import MemberUserInfoAPIResponse from "./member-user-info-api-response";


export default class EntityMembershipsUserInfoAPIResponse {
    membershipUsers?: MemberUserInfoAPIResponse[];
}
